import type { Translations } from '@layers/app/stores/types/locale.ts'

import {
  E164_PHONE_PATTERN,
  SWEDISH_CUSTOMER_SERVICE_PHONE_PATTERN,
} from '@layers/web/constants/customer-service.ts'
import type { CustomerServicePhone } from '@layers/web/constants/types/customer-service.ts'

const replaceCustomerServicePhone = (
  translations: Translations,
  phone: CustomerServicePhone
): Translations =>
  Object.fromEntries(
    Object.entries(translations).map(([key, value]) => [
      key,
      value.replace(
        SWEDISH_CUSTOMER_SERVICE_PHONE_PATTERN,
        match => E164_PHONE_PATTERN.test(match) ? phone.e164 : phone.display
      ),
    ])
  )

export {
  replaceCustomerServicePhone,
}
